import { SuccessView } from "../shared/components/success-view.js";

interface ContactSuccessProps {
  onResend: () => void;
  name: string;
  smsSent: boolean;
}

export function ContactSuccess({ onResend, name, smsSent }: ContactSuccessProps) {
  return <SuccessView name={name} onResend={onResend} smsSent={smsSent} />;
}
